export const DEFAULT_ACCOUNT_LABEL = 'Account'
